import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';

export const Time = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(72),
  color: theme.palette.text.primary,
  lineHeight: 1,
  fontWeight: 700,
  marginTop: 16
}));